const candle_pattern_strategy = new Map([
  [1, [1, 2, 3]],
  [2, [2, 3, 4]],
  [3, [1, 3, 4]],
  [4, [1, 2, 4]],
  [5, [3, 4, 5]],
  [6, [1, 4, 5]],
  [7, [1, 3, 5]],
  [8, [1, 2, 5]],
  [9, [2, 4, 5]],
  [10, [2, 3, 5]],
  [11, [4, 5, 6]],
  [12, [3, 5, 6]],
  [13, [3, 4, 6]],
  [14, [2, 4, 6]],
  [15, [2, 5, 6]],
  [16, [2, 3, 6]],
  [17, [1, 5, 6]],
  [18, [1, 2, 6]],
  [19, [1, 3, 6]],
  [20, [1, 4, 6]],
]);
export const PivotPatternType = { HIGH: "HIGH", LOW: "LOW" };
function effectiveLastReferenceIndex(lastRefIndex) {
  if (lastRefIndex !== null && lastRefIndex !== undefined) return lastRefIndex + 1;
  return 0;
}
function getCandlePatternSize() {
  return candle_pattern_strategy.size;
}
function generatePatternCandleSet(unprocessedPatternCandles, counter) {
  const idxs = candle_pattern_strategy.get(counter) || [];
  if (!idxs.length) return [];
  const maxPos = idxs[idxs.length - 1];
  if (unprocessedPatternCandles.length < maxPos) return [];
  return idxs.map((pos) => unprocessedPatternCandles[pos - 1]);
}
function getLastPatternType(pivotPattern) {
  const low = pivotPattern.lowPrice;
  const high = pivotPattern.highPrice;
  const lowT = low?.lastUpdatedTime ?? null;
  const highT = high?.lastUpdatedTime ?? null;
  if (lowT && (!highT || lowT > highT)) return PivotPatternType.LOW;
  if (highT && (!lowT || highT > lowT)) return PivotPatternType.HIGH;
  return null;
}
function isEligibleHighPattern(pivotPattern, anchor, bar1, bar2) {
  const lastType = getLastPatternType(pivotPattern);
  const noPivotYet = !pivotPattern.highPrice && !pivotPattern.lowPrice;
  return (noPivotYet || lastType === PivotPatternType.LOW)
    && anchor.low > bar1.low
    && anchor.close > bar1.close
    && anchor.low > bar2.low
    && anchor.close > bar2.close;
}
function isEligibleLowPattern(pivotPattern, anchor, bar1, bar2) {
  const lastType = getLastPatternType(pivotPattern);
  const noPivotYet = !pivotPattern.highPrice && !pivotPattern.lowPrice;
  return (noPivotYet || lastType === PivotPatternType.HIGH)
    && anchor.high < bar1.high
    && anchor.close < bar1.close
    && anchor.high < bar2.high
    && anchor.close < bar2.close;
}
function getHighestHigh(pivotPattern, candleSubList) {
  let high = -Infinity;
  let idx = null;
  for (let i = 0; i < candleSubList.length; i++) {
    const c = candleSubList[i];
    if (c.high > high) {
      high = c.high;
      idx = i;
      pivotPattern.highPrice = { price: high, lastUpdatedTime: new Date(c.timestamp) };
      pivotPattern.tempHighPrice = null;
    }
  }
  return idx;
}
function getLowestLow(pivotPattern, candleSubList) {
  let low = null;
  let idx = null;
  for (let i = 0; i < candleSubList.length; i++) {
    const c = candleSubList[i];
    if (low === null || c.low < low) {
      low = c.low;
      idx = i;
      pivotPattern.lowPrice = { price: low, lastUpdatedTime: new Date(c.timestamp) };
      pivotPattern.tempLowPrice = null;
    }
  }
  return idx;
}
function isEligibleForPatternGeneration(candles, anchorIndex, ok) {
  return ok && (candles.length - anchorIndex) >= 3;
}
export function generatePivots(bars, pivotPatternInput = {}) {
  const pivotPattern = {
    highPrice: pivotPatternInput.highPrice || null,
    lowPrice: pivotPatternInput.lowPrice || null,
    tempHighPrice: pivotPatternInput.tempHighPrice || null,
    tempLowPrice: pivotPatternInput.tempLowPrice || null,
    lastIdentifiedIndex: pivotPatternInput.lastIdentifiedIndex ?? 0,
    anchorIndex: pivotPatternInput.anchorIndex ?? 0,
  };
  let lastReferenceIndex = pivotPattern.lastIdentifiedIndex;
  let anchorIndex = pivotPattern.anchorIndex;
  const pivots = [];
  let ok = true;
  while (isEligibleForPatternGeneration(bars, anchorIndex, ok)) {
    const unprocessedPatternCandles = bars.slice(anchorIndex);
    let isValidRun = true;
    for (let counter = 1; counter <= getCandlePatternSize() && isValidRun; counter++) {
      const three = generatePatternCandleSet(unprocessedPatternCandles, counter);
      if (three.length !== 3) {
        isValidRun = false;
        ok = false;
        break;
      }
      const [anchor, bar1, bar2] = three;
      const bar2Index = bars.indexOf(bar2);
      const start = effectiveLastReferenceIndex(lastReferenceIndex);
      const window = bars.slice(start, bar2Index + 1);
      const pack = (c) => ({
        timestamp: c.timestamp,
        open: c.open,
        high: c.high,
        low: c.low,
        close: c.close,
      });
      if (isEligibleLowPattern(pivotPattern, anchor, bar1, bar2)) {
        const i = getLowestLow(pivotPattern, window);
        lastReferenceIndex = bars.indexOf(window[i]);
        pivotPattern.lastIdentifiedIndex = lastReferenceIndex;
        anchorIndex = bar2Index;
        pivotPattern.anchorIndex = anchorIndex;
        pivots.push({
          type: PivotPatternType.LOW,
          index: lastReferenceIndex + 1,
          arrayIndex: lastReferenceIndex,
          timestamp: bars[lastReferenceIndex].timestamp,
          price: pivotPattern.lowPrice.price,
          anchor: pack(anchor),
          bar1: pack(bar1),
          bar2: pack(bar2),
        });
        isValidRun = false;
      } else if (isEligibleHighPattern(pivotPattern, anchor, bar1, bar2)) {
        const i = getHighestHigh(pivotPattern, window);
        lastReferenceIndex = bars.indexOf(window[i]);
        pivotPattern.lastIdentifiedIndex = lastReferenceIndex;
        anchorIndex = bar2Index;
        pivotPattern.anchorIndex = anchorIndex;
        pivots.push({
          type: PivotPatternType.HIGH,
          index: lastReferenceIndex + 1,
          arrayIndex: lastReferenceIndex,
          timestamp: bars[lastReferenceIndex].timestamp,
          price: pivotPattern.highPrice.price,
          anchor: pack(anchor),
          bar1: pack(bar1),
          bar2: pack(bar2),
        });
        isValidRun = false;
      } else if (counter === getCandlePatternSize()) {
        if (anchorIndex < bars.length - 1) anchorIndex += 1;
        isValidRun = false;
      }
    }
  }
  return { pivots, pivotPattern };
}
